import { render, staticRenderFns } from "./AlertHucha.vue?vue&type=template&id=0ec9c6d4&scoped=true"
import script from "./AlertHucha.vue?vue&type=script&lang=js"
export * from "./AlertHucha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec9c6d4",
  null
  
)

export default component.exports